export const globalSettingsIssuesGeneralTranslationsRoute = {
	name: 'global-settings-issues-general-translations',
	path: '/secure/admin/ViewTranslations!default.jspa',
};
